/**
 * Sample CSV Template Data
 *
 * Since the /public directory is not writable in the current environment,
 * sample CSV data is embedded here as strings and served as downloadable blobs.
 * Each template provides realistic energy data that users can reference when
 * preparing their own CSV files.
 */

export const SAMPLE_TEMPLATES = {
  building_load_profile: {
    filename: 'sample_load_profile.csv',
    label: 'Load Profile Template',
    content: `timestamp,consumption_kwh
2025-01-01T00:00:00Z,95.2
2025-01-01T01:00:00Z,88.7
2025-01-01T02:00:00Z,82.1
2025-01-01T03:00:00Z,78.5
2025-01-01T04:00:00Z,76.3
2025-01-01T05:00:00Z,80.9
2025-01-01T06:00:00Z,102.4
2025-01-01T07:00:00Z,145.8
2025-01-01T08:00:00Z,178.3
2025-01-01T09:00:00Z,195.6
2025-01-01T10:00:00Z,210.2
2025-01-01T11:00:00Z,218.7
2025-01-01T12:00:00Z,225.1
2025-01-01T13:00:00Z,220.4
2025-01-01T14:00:00Z,215.8
2025-01-01T15:00:00Z,208.3
2025-01-01T16:00:00Z,198.6
2025-01-01T17:00:00Z,185.2
2025-01-01T18:00:00Z,210.5
2025-01-01T19:00:00Z,235.8
2025-01-01T20:00:00Z,248.1
2025-01-01T21:00:00Z,230.6
2025-01-01T22:00:00Z,175.3
2025-01-01T23:00:00Z,120.8`,
  },

  pv_generation_profile: {
    filename: 'sample_pv_generation.csv',
    label: 'PV Generation Template',
    content: `timestamp,generation_kw
2025-01-01T00:00:00Z,0.0
2025-01-01T01:00:00Z,0.0
2025-01-01T02:00:00Z,0.0
2025-01-01T03:00:00Z,0.0
2025-01-01T04:00:00Z,0.0
2025-01-01T05:00:00Z,0.0
2025-01-01T06:00:00Z,2.1
2025-01-01T07:00:00Z,18.5
2025-01-01T08:00:00Z,45.3
2025-01-01T09:00:00Z,72.8
2025-01-01T10:00:00Z,95.6
2025-01-01T11:00:00Z,112.4
2025-01-01T12:00:00Z,118.7
2025-01-01T13:00:00Z,115.2
2025-01-01T14:00:00Z,102.8
2025-01-01T15:00:00Z,82.3
2025-01-01T16:00:00Z,55.1
2025-01-01T17:00:00Z,25.8
2025-01-01T18:00:00Z,5.2
2025-01-01T19:00:00Z,0.0
2025-01-01T20:00:00Z,0.0
2025-01-01T21:00:00Z,0.0
2025-01-01T22:00:00Z,0.0
2025-01-01T23:00:00Z,0.0`,
  },

  wind_generation_profile: {
    filename: 'sample_wind_generation.csv',
    label: 'Wind Generation Template',
    content: `timestamp,generation_kw
2025-01-01T00:00:00Z,45.2
2025-01-01T01:00:00Z,52.8
2025-01-01T02:00:00Z,48.3
2025-01-01T03:00:00Z,55.1
2025-01-01T04:00:00Z,61.7
2025-01-01T05:00:00Z,58.4
2025-01-01T06:00:00Z,42.9
2025-01-01T07:00:00Z,35.6
2025-01-01T08:00:00Z,28.3
2025-01-01T09:00:00Z,22.1
2025-01-01T10:00:00Z,18.5
2025-01-01T11:00:00Z,15.2
2025-01-01T12:00:00Z,12.8
2025-01-01T13:00:00Z,16.4
2025-01-01T14:00:00Z,21.7
2025-01-01T15:00:00Z,28.9
2025-01-01T16:00:00Z,35.2
2025-01-01T17:00:00Z,42.8
2025-01-01T18:00:00Z,55.3
2025-01-01T19:00:00Z,68.7
2025-01-01T20:00:00Z,72.1
2025-01-01T21:00:00Z,65.8
2025-01-01T22:00:00Z,58.4
2025-01-01T23:00:00Z,50.2`,
  },

  energy_tariff_data: {
    filename: 'sample_energy_tariff.csv',
    label: 'Energy Tariff Template',
    content: `timestamp,import_price_eur_kwh
2025-01-01T00:00:00Z,0.08
2025-01-01T01:00:00Z,0.08
2025-01-01T02:00:00Z,0.08
2025-01-01T03:00:00Z,0.08
2025-01-01T04:00:00Z,0.08
2025-01-01T05:00:00Z,0.08
2025-01-01T06:00:00Z,0.10
2025-01-01T07:00:00Z,0.12
2025-01-01T08:00:00Z,0.15
2025-01-01T09:00:00Z,0.18
2025-01-01T10:00:00Z,0.20
2025-01-01T11:00:00Z,0.22
2025-01-01T12:00:00Z,0.22
2025-01-01T13:00:00Z,0.20
2025-01-01T14:00:00Z,0.18
2025-01-01T15:00:00Z,0.15
2025-01-01T16:00:00Z,0.15
2025-01-01T17:00:00Z,0.18
2025-01-01T18:00:00Z,0.25
2025-01-01T19:00:00Z,0.28
2025-01-01T20:00:00Z,0.25
2025-01-01T21:00:00Z,0.20
2025-01-01T22:00:00Z,0.12
2025-01-01T23:00:00Z,0.10`,
  },

  feed_in_tariff_data: {
    filename: 'sample_feed_in_tariff.csv',
    label: 'Feed-in Tariff Template',
    content: `timestamp,export_price_eur_kwh
2025-01-01T00:00:00Z,0.04
2025-01-01T01:00:00Z,0.04
2025-01-01T02:00:00Z,0.04
2025-01-01T03:00:00Z,0.04
2025-01-01T04:00:00Z,0.04
2025-01-01T05:00:00Z,0.04
2025-01-01T06:00:00Z,0.05
2025-01-01T07:00:00Z,0.06
2025-01-01T08:00:00Z,0.07
2025-01-01T09:00:00Z,0.08
2025-01-01T10:00:00Z,0.09
2025-01-01T11:00:00Z,0.10
2025-01-01T12:00:00Z,0.10
2025-01-01T13:00:00Z,0.09
2025-01-01T14:00:00Z,0.08
2025-01-01T15:00:00Z,0.07
2025-01-01T16:00:00Z,0.07
2025-01-01T17:00:00Z,0.08
2025-01-01T18:00:00Z,0.10
2025-01-01T19:00:00Z,0.12
2025-01-01T20:00:00Z,0.10
2025-01-01T21:00:00Z,0.08
2025-01-01T22:00:00Z,0.06
2025-01-01T23:00:00Z,0.05`,
  },

  building_energy_bill: {
    filename: 'sample_energy_bill.csv',
    label: 'Energy Bill Template',
    content: `period_start,period_end,consumption_kwh,cost_eur
2025-01-01,2025-01-31,3850,962.50
2025-02-01,2025-02-28,3520,880.00
2025-03-01,2025-03-31,3180,795.00
2025-04-01,2025-04-30,2750,687.50
2025-05-01,2025-05-31,2480,620.00
2025-06-01,2025-06-30,2950,737.50
2025-07-01,2025-07-31,3650,912.50
2025-08-01,2025-08-31,3800,950.00
2025-09-01,2025-09-30,3100,775.00
2025-10-01,2025-10-31,2680,670.00
2025-11-01,2025-11-30,3200,800.00
2025-12-01,2025-12-31,3950,987.50`,
  },

  weather_solar: {
    filename: 'sample_weather_solar.csv',
    label: 'Solar Weather Template',
    content: `timestamp,ghi_w_m2,temperature_c,cloud_cover_pct
2025-01-01T00:00:00Z,0,3.2,80
2025-01-01T01:00:00Z,0,2.8,80
2025-01-01T02:00:00Z,0,2.5,75
2025-01-01T03:00:00Z,0,2.1,75
2025-01-01T04:00:00Z,0,1.9,70
2025-01-01T05:00:00Z,0,1.8,70
2025-01-01T06:00:00Z,5,2.0,65
2025-01-01T07:00:00Z,40,3.1,60
2025-01-01T08:00:00Z,120,4.8,55
2025-01-01T09:00:00Z,230,6.9,50
2025-01-01T10:00:00Z,320,8.7,45
2025-01-01T11:00:00Z,375,10.2,40
2025-01-01T12:00:00Z,390,11.1,40
2025-01-01T13:00:00Z,360,11.4,45
2025-01-01T14:00:00Z,285,10.8,50
2025-01-01T15:00:00Z,175,9.5,55
2025-01-01T16:00:00Z,70,7.8,60
2025-01-01T17:00:00Z,10,6.2,65
2025-01-01T18:00:00Z,0,5.1,70
2025-01-01T19:00:00Z,0,4.5,75
2025-01-01T20:00:00Z,0,4.0,75
2025-01-01T21:00:00Z,0,3.7,80
2025-01-01T22:00:00Z,0,3.4,80
2025-01-01T23:00:00Z,0,3.1,80`,
  },

  weather_wind: {
    filename: 'sample_weather_wind.csv',
    label: 'Wind Weather Template',
    content: `timestamp,wind_speed_m_s,wind_direction_deg,temperature_c
2025-01-01T00:00:00Z,5.2,220,3.2
2025-01-01T01:00:00Z,5.8,225,2.8
2025-01-01T02:00:00Z,6.1,230,2.5
2025-01-01T03:00:00Z,5.5,228,2.1
2025-01-01T04:00:00Z,4.9,225,1.9
2025-01-01T05:00:00Z,4.6,220,1.8
2025-01-01T06:00:00Z,4.8,218,2.0
2025-01-01T07:00:00Z,5.4,222,3.1
2025-01-01T08:00:00Z,6.3,230,4.8
2025-01-01T09:00:00Z,7.1,238,6.9
2025-01-01T10:00:00Z,7.8,245,8.7
2025-01-01T11:00:00Z,8.2,250,10.2
2025-01-01T12:00:00Z,8.5,252,11.1
2025-01-01T13:00:00Z,8.1,248,11.4
2025-01-01T14:00:00Z,7.6,244,10.8
2025-01-01T15:00:00Z,7.0,240,9.5
2025-01-01T16:00:00Z,6.4,235,7.8
2025-01-01T17:00:00Z,6.0,232,6.2
2025-01-01T18:00:00Z,5.7,228,5.1
2025-01-01T19:00:00Z,5.4,225,4.5
2025-01-01T20:00:00Z,5.1,222,4.0
2025-01-01T21:00:00Z,4.9,220,3.7
2025-01-01T22:00:00Z,5.0,221,3.4
2025-01-01T23:00:00Z,5.1,222,3.1`,
  },
};


/**
 * Trigger a download of a sample CSV template.
 *
 * @param {string} datasetType - e.g. "building_load_profile"
 */
export const downloadSampleTemplate = (datasetType) => {
  const template = SAMPLE_TEMPLATES[datasetType];
  if (!template) {
    console.warn(`No sample template for dataset type: ${datasetType}`);
    return;
  }

  const blob = new Blob([template.content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = template.filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
};
